"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.text = void 0;

var _stylitas = require("@creditas/stylitas");

const text = ({
  theme
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.typography.support(theme)}
  color: ${_stylitas.utilities.palette.color(theme, 'neutral07')};
  margin-top: 24px;
`;

exports.text = text;